import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { of } from 'rxjs';
import { WINDOW } from '../app.module';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {
  constructor(private httpClient: HttpClient, @Inject(WINDOW) private window: Window) {}

  /**
   * Handle requests with the auth_token param.
   * When the param is present, perform a request to the API to authenticate the user and,
   * with a successfull response, redirect the user to the same URL without the auth_token param,
   * with a failed response, redirect the user to the sign in page.
   * When there is no auth_token param, return an observable that emits true.
   */
  public authenticateWithToken() {
    const url = new URL(this.window.location.href);
    const authToken = url.searchParams.get('auth_token');

    if (!authToken) {
      return () => of(true);
    }

    this.httpClient
      .get(`${this.window.location.origin}/api/v1/auth_tokens`, {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Accept: 'application/json',
          'X-Auth-Token': authToken
        }
      })
      .subscribe(
        (_success) => {
          this.window.location.href = `${url.origin}${url.pathname}`;
        },
        (_error) => {
          this.window.location.href = `${url.origin}/users/sign_in`;
        }
      );
  }
}
